import { AfterViewChecked, Component, EventEmitter, Input, OnInit, DoCheck, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReportsServiceService } from '../../services/reports-service';
import { User } from '../../Models/user';
import { AdminService} from '../../services/admin.service';
import { BusinessProcessService } from '../../services/business-process.service';
import { BpAdministrationService } from '../../services/bp-administration.service';
import { Utils } from '../../services/utils';
import { DateTimeService } from '../../services/date-time.service';
import { CustomValidator } from '../../services/custom-validator';

@Component({
  selector: 'app-reports-filter',
  templateUrl: './reports-filter.component.html',
  styleUrls: ['./reports-filter.component.css']
})
export class ReportsFilterComponent implements OnInit, AfterViewChecked, DoCheck {

  businessProcessList: any[];
  @Input() reportFilterType: ReportFilterType;
  @Input() collapsed$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  @Output() onSearch: EventEmitter<any> = new EventEmitter();
  @Output() onResetFilter: EventEmitter<any> = new EventEmitter();
  utilsFuncs = Utils;
  statesList: any[];
  fieldsList: any[];
  availableUsers: User[];
  instanceIdModel: string;
  stateLifeCycles: string[];
  filterReportForm: FormGroup;
  dmSelectedBusinessProcess = [];
  dmSelectedStates = [];
  dmSelectedLifeCycles = [];
  dmSelectedUsers = [];
  moreThanOneOrAnyBusinessProcessIsSelected$ = new BehaviorSubject<any>(true);
  instanceIdHasValue$ = new BehaviorSubject<any>(false);
  disableState$ = new BehaviorSubject<boolean>(true);
  clauses: Clauses[];
  validClauses = true;
  validInstanceId = true;
  showInstanceId: boolean;
  showUser: boolean;
  showState: boolean;
  showFields: boolean;
  showOverrideStatus: boolean;
  showTimeUnits: boolean;
  showGroupBy: boolean;
  showRanges: boolean;
  showHasReview: boolean;
  showStateLifeCycles: boolean;
  singleBusinessProcess: boolean;
  singleState: boolean;
  requireBusinessProcess: boolean;
  requiredLifeCycle: boolean;
  singleStateLifeCycle: boolean;
  overrideStatusTypes = [];
  timeUnits = [
    { value: 1, name: 'Milissegundos', factor: 1 },
    { value: 2, name: 'Segundos', factor: 1000 },
    { value: 3, name: 'Minutos', factor: 60000 },
    { value: 4, name: 'Horas', factor: 3600000 },
    { value: 5, name: 'Dias', factor: 86400000 }
  ];
  groupBy = [
    { value: 0, name: 'Somente por estado', content: [2] },
    { value: 1, name: 'Somente por usuário', content: [1] },
    { value: 2, name: 'Por estado e usuário', content: [2, 1] },
    { value: 3, name: 'Por usuário e estado', content: [1, 2] }
  ];
  hasReviewOptions = [
    { value: true, name: 'Sim'},
    { value: false, name: 'Não'},
    { value: null, name: 'Indiferente'}
  ];
  get formData() { return this.filterReportForm.controls; }
  get dateRangeData() { return this.formData.dateRange['controls']; }
  get reviewDateRangeData() { return this.formData.reviewDateRange['controls']; }
  get fieldValuesData() { return this.formData.fieldValues['controls']; }

  constructor(
    private formBuilder: FormBuilder,
    private admService: AdminService,
    private bpService: BusinessProcessService,
    private reportService: ReportsServiceService,
    private bpAdmService: BpAdministrationService,
    private dateTimeService: DateTimeService
  ) { }

  ngOnInit() {
    if (!this.reportFilterType) {
      this.reportFilterType = ReportFilterType.instanceHistory;
    }
    this.singleState = false;
    this.applyReportFilterType();

    this.createForm();
    this.loadBusinessProcessList();
    this.loadStateLifeCycles();

    this.loadUsersDropdown();
    this.setFirstClause();
    if (this.reportFilterType === 3) {
      this.setTimingAnalysisInitialValues();
    }

    if (this.showOverrideStatus) {
      this.loadOverrideStatusType();
    }

    if (this.collapsed$) {
      this.collapsed$.subscribe(val => {
        if (val) {
          // @ts-ignore
          $('#cardFilter').CardWidget('collapse');
        } else {
          // @ts-ignore
          $('#cardFilter').CardWidget('expand');
        }
      });
    }
  }

  ngDoCheck() {
    if (this.filterReportForm) {
      this.moreThanOneOrAnyBusinessProcessIsSelected$.subscribe(
        () => {
          this.disableState();
        }
      );
      this.instanceIdHasValue$.subscribe(
        value => {
          this.disableState();
          value ? this.filterReportForm.disable() : this.filterReportForm.enable();
        }
      );
    }
  }

  applyReportFilterType() {
    switch (this.reportFilterType) {
      case ReportFilterType.instanceHistory:
        this.showInstanceId = true;
        this.showUser = true;
        this.showState = true;
        this.showFields = true;
        this.singleBusinessProcess = false;
        this.showStateLifeCycles = true;
        break;
      case ReportFilterType.instanceHistoryStateLifeCycle:
        this.showInstanceId = false;
        this.showUser = false;
        this.showState = true;
        this.showFields = true;
        this.singleBusinessProcess = false;
        this.showStateLifeCycles = true;
        break;
      case ReportFilterType.overrideInstance:
        this.showInstanceId = true;
        this.showUser = false;
        this.showState = false;
        this.showFields = false;
        this.singleBusinessProcess = true;
        this.requireBusinessProcess = false;
        this.showOverrideStatus = true;
        this.singleStateLifeCycle = true;
        this.showStateLifeCycles = true;
        break;
      case ReportFilterType.timingAnalysis:
        this.showInstanceId = false;
        this.showUser = false;
        this.showState = false;
        this.showFields = false;
        this.singleBusinessProcess = true;
        this.requireBusinessProcess = true;
        this.requiredLifeCycle = true;
        this.singleStateLifeCycle = true;
        this.showTimeUnits = true;
        this.showGroupBy = true;
        this.showRanges = true;
        this.showStateLifeCycles = true;
        break;
        case ReportFilterType.review:
        this.showInstanceId = true;
        this.showUser = false;
        this.showState = true;
        this.showFields = false;
        this.singleBusinessProcess = true;
        this.requireBusinessProcess = true;
        this.requiredLifeCycle = false;
        this.singleStateLifeCycle = false;
        this.showTimeUnits = false;
        this.showGroupBy = false;
        this.showRanges = false;
        this.showHasReview = true;
          this.showStateLifeCycles = false;
          this.singleState = true;
        break;
    }
  }

  loadBusinessProcessList() {
    this.bpService.getAllBusinessProcessesPublished()
      .subscribe(
        result => {
          this.businessProcessList = result;
        }, error1 => console.error(error1)
      );
  }

  loadOverrideStatusType() {
    this.bpAdmService.getOverrideStatusTypes().subscribe(r => {
      this.overrideStatusTypes = r.filter(t => {
        return t.value == 1 || t.value == 3 || t.value == 4;
      });
    });
  }
  ngAfterViewChecked() {
    const listItems = <HTMLCollectionOf<Element>>document.getElementsByClassName('ng-option');
    if (this.availableUsers && this.showUser) {
      this.changeColorData(listItems, this.availableUsers);
    }
  }

  changeColorData(listItems: HTMLCollectionOf<Element>, availableItems: any[]) {
    availableItems.forEach( item => {
      for (let i = 0 ; i < listItems.length ; i++ ) {
        if ( !item.enabled && item.logon === (<HTMLElement>listItems[i].children[0]).innerText )  {
          const item1 = <HTMLElement>listItems[i].children[0];
          item1.style.color = '#ccc';
        }
      }
    });
  }

  loadUsersDropdown() {
    this.admService.loadUserList()
      .subscribe(result => {
        this.availableUsers = result;
      }, error => console.error(error));
  }

  getStatesAndFields(businessProcessId) {
    this.loadFieldsDropDown(businessProcessId);
    this.loadStatesDropDown(businessProcessId);
  }

  loadStatesDropDown(businessProcessId: number) {
    this.bpService.getStatesByBusinessProcessId(businessProcessId)
      .subscribe(result => {
          this.statesList = result;
        }, error => console.error(error)
      );
  }

  loadFieldsDropDown(businessProcessId: number) {
    this.fieldsList = this.businessProcessList[this.businessProcessList
      .map(bp => bp.businessProcessId).indexOf(businessProcessId)].fields;
    this.fieldsList = this.fieldsList.sort((a, b) => a.name.localeCompare(b.name));
  }


  loadStateLifeCycles() {
    if (this.reportFilterType == ReportFilterType.overrideInstance) {
      this.reportService.getStateLifeCyclesForOverride()
        .subscribe(
          result => {
            this.stateLifeCycles = result;
          }, error => {
            console.error(error);
          }
        );
    } else {
      this.reportService.getStatesLifeCycles()
        .subscribe(
          result => {
            this.stateLifeCycles = result;
          }, error1 => {
            console.error(error1);
          }
        );
    }
  }

  createForm() {
    this.filterReportForm = this.formBuilder.group({
      businessProcessInstanceId: null,
      businessProcess: [[]],
      businessProcessId: this.requireBusinessProcess ? [null, Validators.required] : null,
      states: [[]],
      stateId: this.requireBusinessProcess ? [null, Validators.required] : null,
      stateLifeCycles: [[]],
      stateLifeCycleValue: null,
      users: [[]],
      pageIndex: null,
      fieldValues: this.formBuilder.group({
        composition: 'all',
        clauses: [[]]
      }),
      dateRange: this.formBuilder.group({
        start: [ this.currentDayInterval().start, [Validators.required] ],
        end: [ this.currentDayInterval().end, [Validators.required] ]
      }),
      reviewDateRange: this.formBuilder.group({
        start: [ this.currentDayInterval().start, [Validators.required] ],
        end: [ this.currentDayInterval().end, [Validators.required] ]
      }),
      overrideStatus: null,
      timeUnitValue: null,
      grouping: null,
      hasReview: true,
      firstRange: this.reportFilterType === 3 ? [null, [Validators.required]] : null,
      secondRange: this.reportFilterType === 3 ? [null, [Validators.required]] : null,
      thirdRange: this.reportFilterType === 3 ? [null, [Validators.required]] : null
    });
    this.filterReportForm.controls['dateRange'].setValidators(CustomValidator.validateDatetime('start', 'end'));
  }

  setTimingAnalysisInitialValues() {
    this.filterReportForm.patchValue({
      firstRange: 5,
      secondRange: 10,
      thirdRange: 20,
      grouping: 0,
      timeUnitValue: 2,
      stateLifeCycleValue: 2
    });
  }

  setRangeValidators() {
    const firstRangeValue = this.filterReportForm.get('firstRange').value;
    const secondRangeValue = this.filterReportForm.get('secondRange').value;
    const thirdRangeValue = this.filterReportForm.get('thirdRange').value;
    this.filterReportForm.get('firstRange').setValidators([Validators.min(0), Validators.max(secondRangeValue - 1), Validators.required]);
    this.filterReportForm.get('secondRange').setValidators([Validators.min(firstRangeValue), Validators.max(thirdRangeValue - 1), Validators.required]);
    this.filterReportForm.get('thirdRange').setValidators([Validators.min(secondRangeValue), Validators.max(99999), Validators.required]);
    this.filterReportForm.updateValueAndValidity();
  }

  setFirstClause() {
    const firstClause = {
      field: null,
      fieldValue: null,
      ordinal: 1
    };
    this.clauses = [firstClause];
  }

  disableOtherFields(modelErrors = null) {
    this.validInstanceId = modelErrors === null;
    if (this.instanceIdModel !== null && this.instanceIdModel !== '') {
      this.instanceIdHasValue$.next(true);
      this.filterReportForm.clearValidators();
    } else {
      this.instanceIdHasValue$.next(false);
      this.filterReportForm.get('dateRange').get('start').setValidators([Validators.required]);
      this.filterReportForm.get('dateRange').get('end').setValidators([Validators.required]);
    }
    this.filterReportForm.updateValueAndValidity();
  }

  disableState() {
    this.moreThanOneOrAnyBusinessProcessIsSelected$
      .subscribe( moreThanOneBPIsSelected => {
        this.instanceIdHasValue$.subscribe( instanceIdHasValue => {
          if (moreThanOneBPIsSelected || instanceIdHasValue) {
            this.disableState$.next(true);
          } else {
            this.disableState$.next(false);
          }
        });
      });
  }

  getSelectedBusinessProcess(items) {
    this.moreThanOneOrAnyBusinessProcessIsSelected$.next(true);
    this.dmSelectedBusinessProcess = items;
    if (items && items.length === 1) {
      this.moreThanOneOrAnyBusinessProcessIsSelected$.next(false);
      this.filterReportForm.get('fieldValues').enable();
      this.getStatesAndFields(items[0]);
    } else {
      this.dmSelectedStates = [];
      this.clauses = [];
      this.validClauses = true;
      this.filterReportForm.get('fieldValues').disable();
      this.setFirstClause();
    }
  }

  changeSingleBusinessProcess(item) {
    this.moreThanOneOrAnyBusinessProcessIsSelected$.next(false);
    this.loadStatesDropDown(item.businessProcessId);
  }

  getSelectedStates(items) {
    this.dmSelectedStates = items;
  }

  getSelectedLifeCycles(items) {
    this.dmSelectedLifeCycles = items;
  }

  getSelectedUsers(items) {
    this.dmSelectedUsers = items;
  }

  clearBusinessProcessId() {
    this.instanceIdModel = null;
    if (this.showInstanceId) {
      document.getElementById('instanceId').focus();
    }
    this.disableOtherFields();
  }

  resetFilter() {
    this.createForm();
    this.clearBusinessProcessId();
    this.dmSelectedStates = [];
    this.dmSelectedBusinessProcess = [];
    this.dmSelectedLifeCycles = [];
    this.dmSelectedUsers = [];
    this.statesList = [];
    this.fieldsList = [];
    this.clauses = [];
    this.moreThanOneOrAnyBusinessProcessIsSelected$.next(true);
    this.validClauses = true;
    this.setFirstClause();
    if (this.onResetFilter) {
      this.onResetFilter.emit();
    }
  }

  blockUserInput() {
    return false;
  }

  // Métodos de gerenciamento das cláusulas de busca por campo

  removeClause(removedClause) {
    let newClauseSet = [];
    let validClauses = this.validClauses;
    this.clauses.forEach( clause => {
      if (clause.ordinal !== removedClause.ordinal) {
        newClauseSet.push(clause);
      }
    });
    newClauseSet.forEach(function (clause, index) {
      clause.ordinal = index + 1;
      if (clause.field) {
        clause.fieldValue ? validClauses = true : validClauses = false;
      }
    });
    if (newClauseSet.length === 0) {
      newClauseSet = [{
        field: null,
        fieldValue: null,
        ordinal: 1
      }];
    }
    this.validClauses = validClauses;
    this.clauses = newClauseSet;
    this.maybeAddOneMoreClause();
  }

  getUsedSlots() {
    const filledClausesOnly = [];
    this.clauses.forEach( clause => {
      if (clause.fieldValue !== null && clause.fieldValue !== '') {
        filledClausesOnly.push(clause);
      }
    });
    return filledClausesOnly;
  }

  maybeAddOneMoreClause() {
    let lastUsedSlot = 0;
    let lastUnusedSlot = -1;
    let validClauses = true;
    if (this.clauses) {
      this.clauses.forEach(function (clause, index) {
        if (clause.fieldValue) {
          lastUsedSlot = index;
        } else {
          lastUnusedSlot = index;
        }
        if (clause.field) {
          clause.fieldValue ? validClauses = true : validClauses = false;
        }
      });
      if (this.clauses.length < 3 && lastUsedSlot > lastUnusedSlot) {
        const newSlot = {
          field: null,
          fieldValue: null,
          ordinal: this.clauses.length + 1
        };
        this.clauses.push(newSlot);
      }
    }
    this.validClauses = validClauses;
  }

  getCalculatedRange(selectedTimeUnit, input): number {
    let calculatedRange = input;
    this.timeUnits.forEach(
      timeUnit => {
        if (timeUnit.value == selectedTimeUnit) {
          calculatedRange = timeUnit.factor * input;
        }
      }
    );
    return calculatedRange;
  }

  search() {
    const filter = this.filterReportForm.getRawValue();
    filter.businessProcessInstanceId = this.instanceIdModel === '' ? null : this.instanceIdModel;
    filter.fieldValues.clauses = this.getUsedSlots();
    filter.businessProcess = this.dmSelectedBusinessProcess;
    filter.states = this.dmSelectedStates.length > 0 ? this.dmSelectedStates : null;
    filter.stateLifeCycles = this.dmSelectedLifeCycles;
    filter.users = this.dmSelectedUsers;
    filter.firstRange = this.getCalculatedRange(filter.timeUnitValue, filter.firstRange);
    filter.secondRange = this.getCalculatedRange(filter.timeUnitValue, filter.secondRange);
    filter.thirdRange = this.getCalculatedRange(filter.timeUnitValue, filter.thirdRange);
    filter.grouping = this.groupBy.map(group => group.content)[filter.grouping];
    filter.dateRange.start = this.dateTimeService.toUTC(filter.dateRange.start);
    filter.dateRange.end = this.dateTimeService.toUTC(filter.dateRange.end);
    if (this.onSearch) {
      this.onSearch.emit(filter);
    }
  }

  currentDayInterval = function() {
    const now = new Date();
    return {
      start: new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0)).toISOString()
        .substr(0, 16),
      end: new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59)).toISOString()
        .substr(0, 16)
    };
  };
}

export interface Clauses {
  field: number;
  fieldValue: any;
  ordinal: number;
}

export enum ReportFilterType {
  instanceHistory,
  instanceHistoryStateLifeCycle,
  overrideInstance,
  timingAnalysis,
  review
}
